// Copyright 2018 The MathWorks, Inc.

/**
 * Tailors the standard ProgressBar for hosting on a StatusBar.  Rather than extending ProgressBar this class
 * wraps it in a ContentPane so that its width can be controlled when displayed on a StatusBar.
 * The underlying ProgressBar is implemented such that it fills its parent's width.  Attempts to constrain
 * it by setting its width attribute do not work.
 */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dijit/layout/ContentPane",
    "mw-notifications/ProgressBar",
    "MW/toolstrip/widgets/_WidgetMixin",
    "./RegionMixin",
    "./WidthMixin"
], function (declare, lang, ContentPane, ProgressBar, _WidgetMixin, RegionMixin, WidthMixin) {
    return declare([ContentPane,_WidgetMixin, RegionMixin, WidthMixin], {

        constructor: function (args) {
            var innerArgs = lang.clone(args);
            if (args.id) {
                innerArgs.id = args.id + "_inner";
            }
            if (args.Tag) {
                innerArgs.Tag = args.Tag + "Inner";
            }
            if (args.showPercentage === undefined) {
                innerArgs.showPercentage = false;
            }
            this._progressBar = new ProgressBar(innerArgs);
        },

        buildRendering: function () {
            this.inherited(arguments);
            if (this.width < 0) {
                this.set("width", 120);
            }
            this.set("content", this._progressBar);
            this._progressBar.domNode.classList.add("mwStatusProgressBar");
        },

        /**
         * Override set to pass properties to the wrapped ProgressBar
         */
        set: function(propertyName, propertyValue) {
            if (this._isLocalProperty(propertyName)) {
                this.inherited(arguments);
            } else {
                this._progressBar.set(propertyName, propertyValue);
            }
        },

        /**
         * Override get to obtain properties from the wrapped ProgressBar
         */
        get: function(propertyName) {
            if (this._isLocalProperty(propertyName)) {
                return this.inherited(arguments);
            } else {
                return this._progressBar.get(propertyName);
            }
        },

        _isLocalProperty: function(propertyName) {
            return propertyName === "content" || propertyName === "id" || propertyName === "tag" ||
                   propertyName === "type" || propertyName === "region" ||  propertyName === "width";
        }
    });
});